<div class="portal-header">
  <div class="header-item">
    <img src="assets/images/logo-eprove-surveys-dark.svg" alt="eprove&trade; surveys">
  </div>
  <div auto="ses-login-header" class="header-item title">
    {{'Student Portal' | translate}}
  </div>
  <div class="header-item"></div>
</div>
